
/* Audio46: keyboard and screen-reader handling for add-to-cart errors. */
(function () {
  'use strict';

  function init() {
    var dialog = document.getElementById('errorDrawer');
    if (!dialog) return;

    var active = false;
    var lastTrigger = null;
    var returnFocus = null;

    function focus(el) {
      if (!el || typeof el.focus !== 'function') return;
      try { el.focus({ preventScroll: true }); }
      catch (e) { el.focus(); }
    }

    function cancelAutoClose() {
      if (window.ab && window.ab.drawerTimeout != null) {
        clearTimeout(window.ab.drawerTimeout);
        window.ab.drawerTimeout = null;
      }
      if (window.drawerTimeout != null) {
        clearTimeout(window.drawerTimeout);
        window.drawerTimeout = null;
      }
    }

    function restoreFocus() {
      if (returnFocus && returnFocus.isConnected) focus(returnFocus);
      returnFocus = null;
      lastTrigger = null;
    }

    function syncVisibility() {
      var visible = window.getComputedStyle(dialog).display !== 'none';
      if (visible && !active) {
        active = true;
        returnFocus = lastTrigger && lastTrigger.isConnected
          ? lastTrigger : document.activeElement;
        cancelAutoClose();
        focus(dialog);
      } else if (!visible && active) {
        active = false;
        restoreFocus();
      }
    }

    function closeDialog() {
      if (!active) return;
      active = false;
      cancelAutoClose();
      if (window.jQuery) {
        window.jQuery(dialog).stop(true, true).hide();
      } else {
        dialog.style.display = 'none';
      }
      document.body.classList.remove('showOverly');
      restoreFocus();
    }

    document.addEventListener('click', function (event) {
      if (!event.target || !event.target.closest) return;
      var trigger = event.target.closest(
        '.product-form__cart-submit, .add-to-cart, [data-a46-sticky-add]'
      );
      if (trigger) lastTrigger = trigger;
    }, true);

    document.addEventListener('click', function (event) {
      if (!active || !event.target || !event.target.closest) return;
      if (event.target.closest('#errorDrawer .closeDrawer, .modalOverly')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        closeDialog();
      }
    }, true);

    document.addEventListener('keydown', function (event) {
      if (!active) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        closeDialog();
      } else if (event.key === 'Tab') {
        var items = Array.prototype.filter.call(
          dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]'),
          function (el) { return el.getClientRects().length > 0; }
        );
        if (!items.length) {
          event.preventDefault();
          focus(dialog);
          return;
        }
        var first = items[0];
        var last = items[items.length - 1];
        if (event.shiftKey &&
            (document.activeElement === first || document.activeElement === dialog)) {
          event.preventDefault();
          focus(last);
        } else if (!event.shiftKey &&
                   (document.activeElement === last || document.activeElement === dialog)) {
          event.preventDefault();
          focus(first);
        }
      }
    }, true);

    document.addEventListener('focusin', function (event) {
      if (active && event.target !== dialog && !dialog.contains(event.target)) {
        focus(dialog);
      }
    }, true);

    new MutationObserver(syncVisibility).observe(dialog, {
      attributes: true,
      attributeFilter: ['style', 'class']
    });
    syncVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
